import { requestApi } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const getTypeTreeData = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Type/getTreeData",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
